import { parsePublicBooleanEnv, withRecettePageTitle } from '~/utils/appEnv'

export function useAppEnv() {
  const runtimeConfig = useRuntimeConfig()
  const showRecetteBadge = computed(() => parsePublicBooleanEnv(runtimeConfig.public.showRecetteBadge))

  return {
    showRecetteBadge,
  }
}

export function useRecetteDocumentTitle(): void {
  const { showRecetteBadge } = useAppEnv()

  useHead({
    titleTemplate: (title) => withRecettePageTitle(title, showRecetteBadge.value),
  })
}
